module.exports = __webpack_public_path__ + "static/86-22a5a74c5ad8a3c8a341688923f661b9.png";